// packages
import { geoIdentity, GeoIdentityTransform } from 'd3-geo';
import { Component, h } from 'preact';

// components
import Contest from './Contest';
import HeadshotCandidateRow from './HeadshotCandidateRow';
import SeatPartyDivider from './SeatPartyDivider';
import LayeredMap from './LayeredMap';
import Portal from './Portal';
import AnalysisTable from './AnalysisTable';

// utils
import { isThisIE } from '../utils/platform';
import {
  determineContestTitle
} from '../election-utils';

import raceCandidateColors from '../election-candidate-colors';

import { visibleCandidatesCount } from '../endpoints';

import find from '../utils/find';

import topology from 'Assets/geography/texas_urban.json';

import delegates from 'Data/delegates.json';

const isIE = isThisIE();

interface ContestShowcaseProps {
  container: Element;
  contest: any | null;
  showDelegates: boolean;
  showContestTitleInShowcase: boolean;
  notes: { [key: string]: any };
  asOf: string;
  annotations: { [key: string]: any };
}

interface ContestShowcaseState {
  contestContainer: Element;
  mapContainer: Element;
  countiesContainer: Element;
}

class ContestShowcase extends Component<
  ContestShowcaseProps,
  ContestShowcaseState
> {
  projection: GeoIdentityTransform;
  _countiesPortal: any;

  constructor() {
    super();

    this.projection = geoIdentity().reflectY(true);
  }

  componentDidMount() {
    const { container } = this.props;

    const contestContainer = container.querySelector('.contest-container');
    const mapContainer = container.querySelector('.contest-map-container');
    const countiesContainer = container.querySelector(
      '.contest-counties-container'
    );

    this.setState({ contestContainer, mapContainer, countiesContainer });
  }

  render() {
    const {
      contest,
      asOf,
      notes,
      annotations,
      showDelegates,
      showContestTitleInShowcase,
    } = this.props;
    const { contestContainer, mapContainer, countiesContainer } = this.state;

    // const firstShowcaseRace =
    // const numDelegates = false;
    //   contest && contest.office == 'President'
    //     ? delegates[
    //         `${contest.office.toLowerCase()}-${contest.party.toLowerCase()}`
    //       ]
    //     : false;


    // const headerUsed =
    //   showDelegates == true
    //     ? HeadshotCandidateRow.Header_Prez
    //     : HeadshotCandidateRow.Header;

    const numDelegates = false;
    const headerUsed = HeadshotCandidateRow.Header;

    let candidateColors, sourceMap, ShowcaseRaceWinner;

    if (!contest) return null;

    if (contest) {
      let candidates = contest.candidacies;

      const colorLookup = [contest.office_slug, '-', contest.party].join('')

      candidateColors = raceCandidateColors[colorLookup] || [];

      sourceMap = contest.source;

      ShowcaseRaceWinner = find(
        candidates,
        candidate => candidate.is_winner === true
      );
    }

    return (
      <span>
        {contestContainer && (
          <Portal
            node={contestContainer}
            ref={ref => (this._contestPortal = ref)}
          >
            <Contest
              contest={contest}
              contestTitle={determineContestTitle(contest)}
              showContestTitleInShowcase={showContestTitleInShowcase}
              isShowcaseRace
              renderParty={party => (
                <SeatPartyDivider
                  partyName={party.party}
                  partyBallot={party}
                  isShowcaseRace
                  annotations={annotations}
                  notes={notes}
                  asOf={asOf}
                  showDelegates={showDelegates == true ? true : false}
                  ShowcaseRaceWinner={ShowcaseRaceWinner}
                  source={party.source}
                  tableHeader={headerUsed}
                  columnCount={HeadshotCandidateRow.columnCount}
                  contestTitle={contest.office}
                  showContestTitleInShowcase={showContestTitleInShowcase}
                  renderCandidate={(
                    candidate: any,
                    idx: number,
                    candidatesRender: any,
                    viewAllCandidates: any,
                    { totalVotes }: { totalVotes: number }
                  ) => (
                    <HeadshotCandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      office={party['office']}
                      contestIsCalled={contest.is_called}
                      contestResult={contest.contest_result}
                      isIncumbent={candidate.is_incumbent}
                      isWinner={candidate.is_winner}
                      numDelegates={numDelegates}
                      isViewable={
                        viewAllCandidates || idx < visibleCandidatesCount
                      }
                      party={candidate.party}
                      candidateColors={candidateColors}
                      totalVotesInContest={totalVotes}
                      votes={candidate.votes}
                    />
                  )}
                />
              )}
            />
          </Portal>
        )}
        {!isIE && mapContainer && (
          <Portal node={mapContainer} ref={ref => (this._mapPortal = ref)}>
            <LayeredMap
              topology={topology}
              projection={this.projection}
              candidates={contest.candidacies}
              candidatesRender={candidateColors}
              source={sourceMap}
              counties={contest.counties}
              precinctsReporting={contest.precincts_reporting}
              totalVotes={contest.total_votes}
            />
          </Portal>
        )}
        {countiesContainer && contest && (
          <Portal node={countiesContainer} ref={ref => (this._countiesPortal = ref)}>
            <AnalysisTable
              contest={contest}
              candidates={contest.candidacies}
              counties={contest.counties}
            />
          </Portal>
        )}
      </span>
    );
  }
}

export default ContestShowcase;
